import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import styles from "../styles/customerStyles.module.css";
import useWindowWidth from "../../../hooks/useWindowWidth";
import { Skeleton } from "@mui/material";


export default function OrdersOverviewCircularBar({
  content,
  tracking,
  orderTrack,
  setValue,
  value,
  statusValue,
  isLoading,
  backgroundColor,
  textColor,
  padding,
  globalLoading,
  index,
  selectDate
}) {

  const colorDecisionMaker = (type, tracking) => {
    if (type === "Waiting" || type === "In Transit") {
      // return "#9155FD";
      return "#ffcd03";
    }
    if (type === "Process" || type === "In processing for > 5 days") {
      return "#a2a2a2";
    }

    if (
      (type === "Shipped" && tracking) ||
      type === "In transit for > 15 days"
    ) {
      return "#9155FD";
    }
    if (
      type === "Attention" ||
      type === "Warning" ||
      type === "Latest update was > 5 days ago"
    ) {
      return "#ffcd03";
    }
    if (type === "Processing" || type === "Picked up" || type === "pending") {
      // return "#659BF4";
      return "#a2a2a2";
    }
    if (
      type === "Delivered" ||
      type === "Shipped" ||
      type === "Returned to overseas warehouse"
    ) {
      return "#6FD226";
    } else {
      return "#FF6F6F";
    }
  };

  const handleChange = () => {
    switch (content.id) {
      case 1:
        setValue(1);
        break;
      case 2:
        setValue(2);
        break;
      case 3:
        setValue(3);
        break;
      case 4:
        setValue(4);
        break;
      case 5:
        setValue(5);
        break;
      case 6:
        setValue(2);
        break;
      case 7:
        setValue(1);
        break;
      case 8:
        setValue(3);
        break;

      default:
        break;
    }
  };

  const ProgressProvider = ({ valueStart, valueEnd, children }) => {
    const [Itemvalue, setItemValue] = React.useState(valueStart);
    React.useEffect(() => {
      setItemValue(valueEnd);
    }, [valueEnd]);

    return children(Itemvalue);
  };

  const windowWidth = useWindowWidth();


  return (
    <div
      className={styles.bar_container}
      onClick={handleChange}
      style={{
        background: backgroundColor ? backgroundColor : "#fff",
        color: backgroundColor ? "#fff" : "#000",
        display: "flex",
        boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px",
        borderRadius: "10px",
        padding:
          windowWidth <= 1525 ? "8px 5px" : padding ? padding : "15px 10px",
        cursor: "pointer",
        transition: "all 0.3s ease-in-out",
        alignItems: "center",
        border: backgroundColor ? "1px solid #1e1532" : "",
      }}
    >
      <div
        style={{
          maxWidth:
            windowWidth <= 1300
              ? "45px"
              : windowWidth > 1600 && windowWidth <= 1800
              ? "70px"
              : windowWidth <= 1600
              ? "60px"
              : "80px",
          maxHeight:
            windowWidth <= 1300
              ? "45px"
              : windowWidth > 1600 && windowWidth <= 1800
              ? "70px"
              : windowWidth <= 1600
              ? "60px"
              : "80px",
        }}
      >
        <ProgressProvider
          valueStart={0}
          valueEnd={content?.percent || statusValue?.percentage}
        >
          {(value) => (
            <CircularProgressbar
              value={isLoading ? 0 : value}
              text={""}
              styles={buildStyles({
                textSize: "18px",
                pathColor: colorDecisionMaker(content.type, tracking),
                textColor: "#5C5C5C",
                trailColor: "#d6d6d6",
              })}
            />
          )}
        </ProgressProvider>
      </div>
      <div
        style={{
          marginTop: "5px",
          marginLeft: windowWidth <= 1525 ? "8px" : "15px",
        }}
      >
        {content.id < 5 && (
          <h6
            className={styles.circular_title}
            style={{
              fontWeight: 600,
              fontSize:
                windowWidth > 1525 && windowWidth <= 1800
                  ? "12px"
                  : windowWidth <= 1525
                  ? "10px"
                  : "14px",

              color: textColor ? textColor : "inherit",
              marginBottom: windowWidth > 1700 ? 10 : 0,
              // marginTop:windowWidth <= 1525 ? 0:'10px'
            }}
          >
            {content.type} Orders
          </h6>
        )}
        {globalLoading ? (
          <Skeleton
            variant="rounded"
            height={25}
            width="100%"
            sx={{ marginTop: "10px" }}
          />
        ) : (
          <h4
            style={{
              fontSize: windowWidth <= 1525 ? "14px" : "20px",
              margin: 0,
            }}
          >
            {content.amount === 0 ? "-" : `€${content.amount}`}
          </h4>
        )}
        {globalLoading ? (
          <Skeleton
            variant="rounded"
            height={20}
            width="100%"
            sx={{ marginTop: "10px" }}
          />
        ) : (
          <h6
            style={{
              fontSize: windowWidth <= 1525 ? "11px" : "",
              marginTop: windowWidth <= 1525 ? "0px" : "10px",
              marginBottom: "5px",
              color: "#797979",
            }}
          >
            {content.items} items
          </h6>
        )}
      </div>
    </div>
  );
}
